import { Input } from "@chakra-ui/react";
import React from "react";
import Select from 'react-select'
import { FieldItems } from "../../../types/layout";
import CustomDatePicker from "../date";

type Props = { 
    field: string | FieldItems[],
    computeTimeFilter: (value?: any, values?: any) => void;
    setInputFilterValue: (e: React.ChangeEvent<HTMLInputElement>) => void;
    computeFilterValue: (value: any) => void
}

export default function FilterItem({ 
    field, 
    computeTimeFilter, 
    setInputFilterValue,
    computeFilterValue ,
    setTagKey
}: Props & { setTagKey: any }) {
    // function handleFilterItemValueChange(value: any) {
    //     console.log({ handleFilterItemValueChange: value });
    //     setTagKey(true)
    //     computeFilterValue && computeFilterValue(value)
    // } 

    function renderItems(value: string | FieldItems[]): JSX.Element {
        // let modifiedOptionsAsArr;

        // if (typeof value === 'object' && value?.length) {
        //     modifiedOptionsAsArr = value.map((item) => ({ 
        //         ...item, 
        //         label: item?.displayName || item.id || item.name || item.value || "",
        //         value: item?.displayName || item.id || item.name || item.value || ""
        //     }))
        // }
        
        if (typeof value === 'string') {
            if (value === 'time') {
                return (
                    <CustomDatePicker 
                        selectsRange
                        onChange={(date) => computeTimeFilter(date)} 
                    />
                )
            }

            return (
                <Input 
                    id='filterSearch'
                    maxLength={100}
                    type='text'
                    // value={currentFilters?.[property]}
                    onChange={(value) => setInputFilterValue(value)}
                />
            )
        } else {
            return (
                <Select 
                    isClearable
                    className="react-select-filter mr--10"
                    isSearchable
                    isMulti
                    onChange={(value) => computeFilterValue(value!)}
                    getOptionLabel={(option) => option?.displayName || option.id || option.name || option.value || ""}
                    options={value}
                />
            )
        }
    }

    return (
        <>
            {renderItems(field)}
        </>
    )
}